import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import InCourseSearchApp from 'bundles/in-course-search/components/InCourseSearchApp';

const InCourseSearchPage = loadOnRoute(() => import('bundles/in-course-search/components/InCourseSearchPage'));

export default (
  <Route path="/" component={InCourseSearchApp}>
    <Route path="learn/:courseSlug/search" getComponent={InCourseSearchPage} />
  </Route>
);
